import {useCallback, useEffect, useRef, useState} from 'react';
import {Alert, Box} from '@mui/material';
import {FsDetail} from '@/audit/finance-statement';
import {useFsCreateCtx} from '@/pages/components/audit/finance-statement/create-stepper/context';

const PANEL_HEIGHT = 'calc(100vh - 260px)';

export default function StepDFs() {
    const {state, dispatch} = useFsCreateCtx();
    const detailRef = useRef<{
        getLines: () => {
            bsLines: Array<{ fsId: number; amount: number; lastYearChangeAudited?: number }>;
            plLines: Array<{ fsId: number; amount: number; lastYearChangeAudited?: number }>
        } | null
    } | null>(null);
    
    const [hasLoggedValidation, setHasLoggedValidation] = useState(false);

    useEffect(() => {
        // expose getLines to parent via context
        dispatch({type: 'set_get_lines', payload: () => detailRef.current?.getLines?.() || null});
        return () => {
            dispatch({type: 'set_get_lines', payload: undefined});
            dispatch({type: 'set_bs_unbalanced', payload: false});
            dispatch({type: 'set_fs_hide_submit', payload: false});
        };
    }, [dispatch]);

    const companyId = Number((state.selectedCompany as any)?.companyId ?? (state.selectedCompany as any)?.id);
    const annualId = Number(state.annualId ?? (state.selectedAnnual as any)?.annualId ?? (state.selectedAnnual as any)?.id);
    const companyName = (state.selectedCompany as any)?.companyName || null;

    const handleBsErrorChange = useCallback((msg?: string | null) => {
        dispatch({type: 'set_bs_unbalanced', payload: !!(msg && String(msg).trim())});
    }, [dispatch]);

    const handleHideSubmitChange = useCallback((hide: boolean) => {
        dispatch({type: 'set_fs_hide_submit', payload: hide});
    }, [dispatch]);

    // 只在首次渲染或值变化时记录日志
    useEffect(() => {
        if (!hasLoggedValidation) {
            setHasLoggedValidation(true);
        }
    }, [companyId, annualId, companyName, hasLoggedValidation, state.selectedCompany, state.selectedAnnual, state.annualId, state.isCreatingAnnual]);

    if (!companyId || !annualId) {
        return (
            <Box sx={{height: PANEL_HEIGHT, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <Alert severity="info">Please complete Step 1 and Step 2.</Alert>
            </Box>
        );
    }

    return (
        <Box sx={{height: PANEL_HEIGHT, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0}}>
            <FsDetail
                ref={detailRef as any}
                companyId={companyId}
                annualId={annualId}
                companyName={companyName}
                hideUpdateButton
                importToken={state.importToken}
                onBsErrorChange={handleBsErrorChange}
                onHideSubmitChange={handleHideSubmitChange}
            />
        </Box>
    );
}
